import React, { useState, useEffect } from 'react';
import './JobPositions.css';

function JobPositions() {
    const [jobPositions, setJobPositions] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const initialDisplayCount = 5; // Adjust based on your layout

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/position-questions-count`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setJobPositions(data);
            } catch (error) {
                console.error('Error fetching data: ', error);
            }
        };

        fetchData();
    }, []);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="job-positions-container">
            <div className="job-positions">
                {jobPositions.slice(0, isExpanded ? jobPositions.length : initialDisplayCount).map(position => (
                    <div key={position.name} className="job-item">
                        {position.name} <span className="job-count">{position.count}</span>
                    </div>
                ))}
            </div>
            {jobPositions.length > initialDisplayCount && (
                <div className="expand" onClick={toggleExpand}>
                    {isExpanded ? 'Collapse' : 'Expand'}
                </div>
            )}
        </div>
    );
}

export default JobPositions;